// src/com/trans_plan_and_actor/TransPlanAndActorGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * 배송현황(센터, 운송사 공통)
 * TRANS_PLAN_AND_ACTOR Apollo Graphql
 * VIEW
 * Project: NewTOP for cloud
 * 2024-12-10 16:28:06 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const TRANS_PLAN_AND_ACTOR_LIST_PART = gql`
fragment TransPlanAndActorListPart on TransPlanAndActor {
    planId
    dcCd
    arriveId
    storeId
    comId
    planDate
    planTime
    hocha
    transTypeCd
    vehTypeId
    vehTypeName
    shprReqTime
    dptrReqTime
    arrReqTime
    dockno
    charge
    note
    reqStateFlag
    transFlag
    vehPlates
    driverName
    driverMobile
    regTypeCd
    zipgiBool
    printDate
    printUser
    printUserName
    regDate
    regUser
    regUserName
    dcName
    comName
    vehInfoSeq
    vehId
    rentYn
    storeName
    transType
    reqState
    unsoldPallet
}
`;

/*

			t1.pass_veh_plate AS passVehPlate,
			t1.pass_seal_date AS passSealDate,
			t1.take_user_id AS takeUserId,
			t1.take_seal_date AS takeSealDate,
			t1.transfered AS transfered,
			t1.pass_name AS passName,
			t1.take_name AS takeName,
*/

const TRANS_PLAN_AND_ACTOR_LIST_SEAL_PART = gql`
fragment TransPlanAndActorListSealPart on TransPlanAndActor {
    passVehPlate
    passSealDate
    takeUserId
    takeSealDate
    transfered
    passName
    takeName
}
`;

// 배송현황
export const LIST_TRANS_PLAN_AND_ACTOR = gql`
${TRANS_PLAN_AND_ACTOR_LIST_PART}
${TRANS_PLAN_AND_ACTOR_LIST_SEAL_PART}
query ListTransPlanAndActor($timeFrom:String!, $timeTill:String!) {
    transPlanAndActorList(timeFrom:$timeFrom, timeTill:$timeTill) {
        ...TransPlanAndActorListPart
        ...TransPlanAndActorListSealPart
    }
}
`;

// 출차완료/출차대기/배차대기 차량 목록
// transPlanListTodayForStatus(dcCd:String!, vehTypeId:String): [TransPlanAndActor]!
export const LIST_TRANS_PLAN_AND_ACTOR_TODAY_FOR_STATUS = gql`
query ListTransPlanAndActorTodayForStatus($dcCd:String!, $reqState:String) {
    transPlanListTodayForStatus(dcCd:$dcCd, reqState:$reqState) {
        planId
        dcCd
        storeId
        storeName
        hocha
        reqStateFlag
        reqState
        dptrReqTime
        arrReqTime
        transTypeCd
        transType
        vehTypeName
        comName
        vehPlates
        transFlag
        driverName
        note
    }
}
`;


// 운송요청 목록:
// transPlanRequestList(planDate:String!, dcCd:String!, storeId:String!): [TransPlanAndActor]!

/*

            const mapUrl = ValueMisc.makeMapUrl({
                    job: MapValue.MapInitEvent.traceVehicle,
                    vehInfoSeqToTrace:veh.vehInfoSeq,
                    vehPlates:veh.vehPlates,
                    vehAlias:veh.vehAlias
                });
            window.open(mapUrl, AppWord.MAP_WINDOW_NAME);

const TRANS_PLAN_AND_ACTOR_NO_LIST_PART = gql`
fragment TransPlanAndActorNoListPart on TransPlanAndActor {
    dcStaffName
    agentStaffName
    cargoStaffName
    cargoTel
    txStage
    addCharge
    bol1
    bol2
    bol3
    loadCount
    loadStTime
    loadEnTime
    prosDptrTime
    prosArrTime
    sealNo1
    sealNo2
    sealNo3
    loadStaffName
    unsoldBol
    unsoldPallet
    unsoldCount
    memo
    inputArrTime
    traceStatus
    endFlag
    inputDptrTime
    inputTempF
    inputTempM
    inputTempR
    dcTypeCd
    dcTypeName
    transPosYn
    takeUserId
    passName
    takeName
}
`;
 */

